'use client';

import { cn } from '@/lib/utils/cn';
import { SectionHeader } from '../shared';

interface AxisWeight {
  name: string;
  weight: number;
  default: number;
  changed?: boolean;
}

interface AxisWeightsSectionProps {
  axes: AxisWeight[] | null | undefined;
  rationale?: string | null;
  label?: string | null;
}

export function AxisWeightsSection({
  axes,
  rationale,
  label,
}: AxisWeightsSectionProps) {
  if (!axes || axes.length === 0) return null;
  return (
    <div>
      <SectionHeader title={label ?? 'Match weights'} />
      {rationale && (
        <p className="text-[11px] text-muted-foreground italic leading-relaxed mb-2">
          {rationale}
        </p>
      )}
      <div className="grid grid-cols-3 gap-1.5">
        {axes.map((a) => (
          <div
            key={a.name}
            className={cn(
              'p-2 rounded-lg border text-center',
              a.changed
                ? 'bg-warning/10 border-warning/40'
                : 'bg-card border-border',
            )}
            title={a.changed ? `default ${a.default}` : undefined}
          >
            <div className="text-sm font-semibold">
              {formatWeight(a.weight)}
            </div>
            <div className="text-[10px] text-muted-foreground">
              {formatAxisLabel(a.name)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function formatWeight(w: number): string {
  // Integer when possible; one decimal otherwise.
  return Number.isInteger(w) ? w.toString() : w.toFixed(1);
}

function formatAxisLabel(name: string): string {
  return name.replace(/_/g, ' ');
}
